import gsap from 'gsap'

import {
  getScrollTriggerOptions,
  linesRevealAnimation,
  linkRevealAnimation,
  paragraphRevealAnimation,
  SharedAnimation
} from './shared'
import { Animation } from '@/types'

export const singleParagraphRevealAnimation = ({
  node,
  mobile,
  context,
  reverse
}: Animation) => {
  if (mobile) return

  const selector = context?.selector || gsap.utils.selector(node)

  const title = selector('[data-motion-title]')[0]
  const link = selector('[data-motion-link]')[0]
  const overline = selector('[data-motion-overline]')[0]
  const paragraph = selector('[data-motion-paragraph]')[0]

  const timeline = gsap.timeline({
    ...getScrollTriggerOptions(node, reverse)
  })

  let overlineAnimation: SharedAnimation
  if (overline) {
    overlineAnimation = linesRevealAnimation(overline, reverse)
    timeline.add(overlineAnimation.timeline, '<')
  }

  let titleAnimation: SharedAnimation
  if (title) {
    titleAnimation = linesRevealAnimation(title, reverse)
    timeline.add(titleAnimation.timeline, '<')
  }

  let paragraphAnimation: SharedAnimation
  if (paragraph) {
    paragraphAnimation = paragraphRevealAnimation(paragraph, reverse)
    timeline.add(paragraphAnimation.timeline, '<+0.2')
  }

  let linkAnimation: SharedAnimation
  if (link) {
    linkAnimation = linkRevealAnimation(link)
    timeline.add(linkAnimation.timeline, '<+0.4')
  }

  return () => {
    timeline.kill()

    titleAnimation?.revert()
    overlineAnimation?.revert()
    paragraphAnimation?.revert()
    linkAnimation?.revert()
  }
}
